<div class="intake-menu-container">
    <app-tab-menu class="member-detail-tabs-menu" orientation="top" (activeIndexChange)="onViewClicked($event)">
        <app-tab-panel header="Charts" [selected]="view === 0"></app-tab-panel>
        <app-tab-panel header="Chases" [selected]="view === 1"></app-tab-panel>
        <app-tab-panel header="Timeline" [selected]="view === 2"></app-tab-panel>
    </app-tab-menu>
</div>
<div class="member-details-tab-container">

    <div class="member-charts-Details section tabContent" *ngIf="this.view === 0">
        <member-detail-body-grids-charts></member-detail-body-grids-charts>
    </div>

    <div class="member-chases-Details section tabContent" *ngIf="this.view === 1">
        <member-member-detail-body-grids-chases></member-member-detail-body-grids-chases>
    </div>

    <div class="member-timeline-Details section tabContent" *ngIf="this.view === 2">
        <app-member-timeline></app-member-timeline>
    </div>
</div>